function getPastedInput(event) {
  event.preventDefault();
  const clipboardData = event.clipboardData || window.clipboardData;
  const pastedData = clipboardData.getData('text');
  return pastedData.replace(/[\r\n]+/g, ' ');
}
export default getPastedInput;